module.exports = new __parcel__URL__("default_right.a801c0cc.svg").toString();